export default {
    getAboutCompany(state) {
        return state.aboutCompany;
    },
};
